// extracted by mini-css-extract-plugin
export var checkbox = "_5l-0";
export var circle = "_5l-3";
export var horizontalContainer = "_5l-7";
export var sm = "_5l-5";
export var switch0 = "_5l-2";
export var switchDisabled = "_5l-8";
export var switchEnabled = "_5l-1";
export var textSwitchContainer = "_5l-9";
export var textSwitchOption = "_5l-a";
export var textSwitchOptionSelected = "_5l-b";
export var verticalContainer = "_5l-6";
export var xs = "_5l-4";